<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <div class="text-xs-center">
      <SvgButtons @openModal="modal=true" @mostrarModalFullScreen="modalFull=true"/>
    </div>
    <modal-app v-model="modal" :fullscreen="false" width="700px">
      <h1 class="modal-title">Desarrolladas</h1>
      <p>Son reservas de cualquier categoría a recuperar mediante yacimientos existentes, con los equipos y métodos operativos instalados o en los cuales el costo del equipo es bajo en comparación con el de un pozo nuevo. <br>Se considera bajo alrededor del 10%.</p>
    </modal-app>
    <modal-app transition="slide-y-transition" blackBg v-model="modalFull" :mostrarCerrar="currentText == 2">
      <dialogos-app ref="dialog1" :dialogos="dialogosModal" :adelanteVisible="currentText!=1 || vistosTexto2.every(el=>{return el})" @update:currentText="currentText = $event, text = 0, $refs.audioPlayer.playAudio($event+1)"></dialogos-app>
      <v-layout align-center>
        <v-flex x12 md8>
          <svg-anim v-if="currentText < 2" :showButtons="currentText == 1" @mostrarTexto="text = $event, $set(vistosTexto2,$event-1,true)"/>
          <svg-reservas v-else @mostrarTexto="text = $event"></svg-reservas>
        </v-flex>
        <v-flex xs12 md4>
          <transition name="text" appear-active-class="animated fadeInDown superfaster" enter-active-class="animated fadeInDown superfaster" leave-active-class="animated fadeOutDown superfaster" mode="out-in">
            <p class="texto1" :key="texto" v-focus v-if="text>0 && currentText>0"><span v-html="texto"></span></p>
          </transition>
        </v-flex>
      </v-layout>
    </modal-app>

    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 2/AUDIO 07',
    'Modulo 2/AUDIO 08',
    'Modulo 2/AUDIO 09',
    'Modulo 2/AUDIO 9-2',
    ]"></audio-player> 
  </div>
</template>

<script>
import SvgButtons from '../../assets/Modulo 2/diapositiva-11'
import SvgAnim from '../../assets/Modulo 2/diapositiva-13'
import SvgReservas from '../../assets/Modulo 2/diapositiva-15'
import { setTimeout } from 'timers';
export default {
  components: {
    SvgButtons,
    SvgAnim,
    SvgReservas
  },
  data() {
    return {
      dialogos: [
        "Las reservas probadas son aquellas cantidades de petróleo y gas que, mediante un análisis de geociencias e ingeniería, pueden ser estimadas con certeza razonable que serán económicamente producibles, a partir de una fecha dada, de yacimientos conocidos, bajo las condiciones económicas de operación y regulaciones gubernamentales existentes. <span class='instruccion'>Haz clic en las reservas desarrolladas y las de producción.</span>" 
      ],
      dialogosModal: [
        "Son las que se espera recuperar de los intervalos cañoneados que están abiertos y en producción en el momento de hacer la estimación.",
        "Incluye reservas en pozos cerrados shut in y detrás de tuberías behind pipe. <span class='instruccion'>Haz clic en los cuadros</span>",
        "Son reservas de cualquier categoría a recuperar de nuevos pozos en áreas no drenadas del yacimiento o de pozos existentes cuando las inversiones son considerables, así. <span class='instruccion'>Haz clic en los círculos 1 y 2.</span>"
      ],
      text: 0,
      modal: false,
      modalFull: false,
      vistosTexto2: [false, false],
      currentText: 0
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  computed: {
    texto: function(){
      if(this.currentText == 1){
        switch(this.text){
          case 1: return '<span class="modal-title">Shut In:</span><br>Son reservas que se espera sean recuperadas de intervalos que están abiertos en el momento de la estimación, pero no empezaron todavía a producir. También se refiere a pozos que se cerraron por condiciones de mercado o conexiones con ductos o pozos que no son capaces de producir por razones mecánicas.';
          case 2: return '<span class="modal-title">Behind pipe:</span><br>Son reservas que se espera sean recuperadas de zonas en pesos existentes que requieren trabajo de cañoneo adicional o recañoneo antes de comenzar la producción. En todos los casos, la producción puede iniciarse con gastos relativamente bajos, comparados con el costo de perforar un pozo nuevo, se considera bajo alrededor del 10%.';
        }
      }
      if(this.currentText == 2){
        switch(this.text){
          case 1: return 'Las reservas en áreas no drenadas del yacimiento deben limitarse a un radio de espaciamiento, si cumple la certeza razonable; a menos que, mediante tecnología confiable, se demuestre la certeza razonable de obtener producción económica a mayores distancias.';
          case 2: return 'Sólo pueden considerarse reservas no desarrolladas cuando se haya adoptado el plan de desarrollo y el mismo cumpla con el criterio de cinco años base, es decir, máximo 5 años para su ejecución.';
        }
      }
      return ''
    }
  },
  watch: {
    modalFull: function(newValue, oldValue){
      if(newValue){
        this.$refs.dialog1.saltarAlDialogo(0)
        this.$refs.audioPlayer.playAudio(1)
      }
      if(!newValue && oldValue){
        this.$store.commit('nextShow', true)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
